import React from 'react'
import styled from 'styled-components'
import 'slick-carousel/slick/slick.css'
import Slider from 'react-slick'
import { useSelector } from 'react-redux'
import CarouselItem from 'src/components/common/ScheduleBannerV2/CarouselItem'
import { defaultCTAURI } from 'src/modules/utils/constants'
import { selectCTAParams } from 'src/modules/reducers/params'
import { createUrl } from 'src/modules/utils/createUrl'
import { replaceUrlParam } from 'src/modules/utils/replaceUrlParam'
import { fireUIInteractionEvent } from 'src/modules/analytics/v3'
import { selectStateForProtobuf } from 'src/modules/reducers'
import { colors, heading, mediaQuery, spacing, typographyMixin } from 'src/constants/marketing-ds'
import { ArrowLeft, ArrowRight } from 'src/components/icons/Arrows'

const ScheduleBanner = ({
  lang = 'en',
  items,
  title,
  subtitle,
  link = defaultCTAURI,
  ctaText,
  ctaHrefOverride,
}) => {
  const stateForProtobuf = useSelector(selectStateForProtobuf)
  const parsedParams = useSelector(selectCTAParams)
  let ctaURL = createUrl(link, parsedParams)
  ctaURL = replaceUrlParam(ctaURL, 'comp', 'matchticker')

  const handleOnClickPrev = (e) => {
    fireUIInteractionEvent(
      {
        component: 'schedule_banner_prev_clicked',
        type: 'clicked',
      },
      stateForProtobuf
    )
  }

  const handleOnClickNext = (e) => {
    fireUIInteractionEvent(
      {
        component: 'schedule_banner_next_clicked',
        type: 'clicked',
      },
      stateForProtobuf
    )
  }

  function PrevArrow(props) {
    const { className, style, onClick } = props
    const handleOnClick = () => {
      onClick && onClick()
      handleOnClickPrev()
    }
    return (
      <div className={className} style={style} onClick={handleOnClick}>
        <ArrowLeft fill="white" />
      </div>
    )
  }

  function NextArrow(props) {
    const { className, style, onClick } = props
    const handleOnClick = () => {
      onClick && onClick()
      handleOnClickNext()
    }
    return (
      <div className={className} style={style} onClick={handleOnClick}>
        <ArrowRight fill="white" />
      </div>
    )
  }

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 2,
    variableWidth: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  }

  return (
    <StyledScheduleBanner>
      {/* <h2>{title}</h2> */}
      <h3>{title}</h3>
      <Slider {...settings} className="carousel-container">
        {items?.map((item, index) => {
          return (
            <CarouselItem
              key={index}
              lang={lang}
              item={item}
              link={ctaHrefOverride || ctaURL}
              index={index}
              ctaText={ctaText}
            />
          )
        })}
      </Slider>
    </StyledScheduleBanner>
  )
}

export default ScheduleBanner

const StyledScheduleBanner = styled.div`
  ${'' /* max-width: 1200px; */}
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: ${spacing.xs} 0;
  gap: ${spacing.md};
  ${mediaQuery.tablet} {
    padding: ${spacing.md} 0;
  }

  @media (max-width: 768px) {
    gap: ${spacing.sm};
    flex-direction: column;
    align-items: flex-start;
  }

  h3 {
    min-width: 165px;
    color: ${colors.white};
    ${typographyMixin(heading.xs)}
    ${mediaQuery.tablet} {
      ${typographyMixin(heading.sm)}
    }
  }

  .slick-list {
    padding: 0 30px;
  }

  .carousel-container {
    display: flex;
    overflow: hidden;
    position: relative;
    align-items: stretch;
    flex: 0 1 auto;
    width: 100%;
  }

  .slick-track {
    height: 100%;
  }

  .slick-slide {
    height: 100%;
    padding: 0 ${spacing.xxxs};
    @media (max-width: 767px) {
      padding: 0 ${spacing.xxxxs};
    }
  }

  .slick-slide > div {
    height: 100%;
  }
  .slick-arrow {
    padding: 0 10px;
    position: absolute;
    height: 100%;
    color: #fff;
    display: flex !important;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s;
    z-index: 5;

    &::before {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
    }

    svg {
      z-index: 5;
      width: 16px;
      ${mediaQuery.tablet} {
        width: 22px;
      }
    }
  }

  .slick-prev {
    left: 0px;
    &::before {
      background: linear-gradient(90deg, ${colors.slate[10]} 39.52%, rgba(11, 12, 18, 0) 100%);
    }
  }

  .slick-next {
    right: 0px;
    &::before {
      // background: linear-gradient(-90deg, #17181f 39.52%, rgba(18, 19, 27, 0) 100%);
      background: linear-gradient(-90deg, ${colors.slate[10]} 39.52%, rgba(11, 12, 18, 0) 100%);

      width: 500%;
      @media (max-width: 768px) {
      }
    }
  }
`
